import { Injectable, Type } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom, race, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class IosDialogService {
  refs = new Set<DynamicDialogRef>();

  constructor(private dialog: DialogService) {}

  /**
   * Opens Prime ng dialog and returns its ref.
   */
  open(component: Type<any>, data: DynamicDialogConfig = {}): DynamicDialogRef {
    const ref = this.dialog.open(component, data);
    this.refs.add(ref);
    race([ref.onClose, ref.onDestroy])
      .pipe(take(1))
      .subscribe(() => {
        if (this.refs.has(ref)) this.refs.delete(ref);
      });
    return ref;
  }

  /**
   * Opens Prime ng dialog and returns a promise of its return values
   */
  openAndWaitResponse<T>(component: Type<any>, data: DynamicDialogConfig = {}): Promise<T> {
    const ref = this.open(component, data);
    return firstValueFrom(ref.onClose);
  }

  /**
   * Closes all open dialogs
   */
  closeAll() {
    [...this.refs].forEach((ref) => ref.destroy());
  }
}
